import { render, staticRenderFns } from "./places.vue?vue&type=template&id=5d338958&"
import script from "./places.vue?vue&type=script&lang=js&"
export * from "./places.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports